import { createReducer } from 'reduxsauce';
import { cloneDeep, filter, isEqual } from 'lodash';

import { ShiftAdminTypes } from '../actions/shift-admin.actions';
import { InsighttNotification } from '../../helpers/insightt-notification';

const initialState = {
  status: [],
  // activeShifts: [],
  // totalRepossessions: [],
  // totalSpottedVehicles: [],
  // totalLPRScans: [],
  // totalUnitsPendingRepossessions: [],
  // peopleInActiveShifts: [],
  // commissionsForActiveShifts: [],
  shiftPrevPeriodOverview: null,
  shiftCommissions: [],
  alertsFeed: [],
  failedChecklistFeed: {},
  manualHotListFeed: [],
  // alertsPaginationFeed: {},
};

// const getActiveShiftsOverviewRequest = (state) => {
//   const status = cloneDeep(state.status);
//   status.push('pending-get-active-shifts-overview');

//   return { ...state, status };
// };
// const getActiveShiftsOverviewSuccess = (state, action) => {
//   const activeShiftsOverview = action.response;

//   const activeShifts = activeShiftsOverview.activeShifts || [];
//   const totalRepossessions = activeShiftsOverview.totalRepossessions || [];
//   const totalSpottedVehicles = activeShiftsOverview.totalSpottedVehicles || [];
//   const totalLPRScans = activeShiftsOverview.totalLPRScans || [];
//   const scans = activeShiftsOverview.Scans || [];
//   const totalUnitsPendingRepossessions = activeShiftsOverview.totalUnitsPendingRepossessions || [];
//   const peopleInActiveShifts = activeShiftsOverview.peopleInActiveShifts || [];
//   const commissionsForActiveShifts = activeShiftsOverview.commissionsForActiveShifts || [];
//   const totalRepossessionHitList = activeShiftsOverview.totalRepossessionHitList || [];

//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-active-shifts-overview', a));

//   return {
//     ...state,
//     activeShifts,
//     totalRepossessions,
//     totalSpottedVehicles,
//     totalLPRScans,
//     scans,
//     totalUnitsPendingRepossessions,
//     peopleInActiveShifts,
//     commissionsForActiveShifts,
//     totalRepossessionHitList,
//     status,
//   };
// };
// const getActiveShiftsOverviewFailure = (state) => {
//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-active-shifts-overview', a));

//   return { ...state, status };
// };

const getShiftPrevPeriodOverviewRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-shift-prev-period-overview');

  return { ...state, shiftPrevPeriodOverview: null, status };
};
const getShiftPrevPeriodOverviewSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-prev-period-overview', a));

  return { ...state, shiftPrevPeriodOverview: action.response, status };
};
const getShiftPrevPeriodOverviewFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-prev-period-overview', a));

  return { ...state, status };
};

const getShiftCommissionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-shift-commissions');

  return { ...state, shiftCommissions: [], status };
};
const getShiftCommissionsSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-commissions', a));

  return { ...state, shiftCommissions: action.response, status };
};
const getShiftCommissionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-commissions', a));

  return { ...state, status };
};

// const getShiftAlertsFeedRequest = (state) => {
//   const status = cloneDeep(state.status);
//   status.push('pending-get-shift-alerts-feed');

//   return { ...state, status };
// };
// const getShiftAlertsFeedSuccess = (state, action) => {
//   const alertsFeed = action.response;
//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-shift-alerts-feed', a));

//   return {
//     ...state,
//     alertsPaginationFeed: alertsFeed,
//     status,
//   };
// };
// const getShiftAlertsFeedFailure = (state) => {
//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-shift-alerts-feed', a));

//   return { ...state, status };
// };

const saveAllInfractionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-save-all-infractions');

  return { ...state, status };
};
const saveAllInfractionsSuccess = (state) => {
  InsighttNotification('success', 'SuccessFully Saved All Infractions.');

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-save-all-infractions', a));

  return {
    ...state,
    // alertsFeed,
    status,
  };
};
const saveAllInfractionsFailure = (state) => {
  InsighttNotification('error', 'Saved All Infractions Failed.');
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-save-all-infractions', a));

  return { ...state, status };
};

// const getShiftAlertsPaginationFeedRequest = (state) => {
//   const status = cloneDeep(state.status);
//   status.push('pending-get-shift-alerts-pagination-feed');

//   return { ...state, status };
// };

// const getShiftAlertsPaginationFeedSuccess = (state, action) => {
//   const alertsPaginationFeed = action.response;

//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-shift-alerts-pagination-feed', a));

//   return {
//     ...state,
//     alertsPaginationFeed,
//     status,
//   };
// };

// const getShiftAlertsPaginationFeedFailure = (state) => {
//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-shift-alerts-pagination-feed', a));

//   return { ...state, status };
// };

const saveUserInfractionAsRecordRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-save-userinfraction-as-record');

  return { ...state, status };
};
const saveUserInfractionAsRecordSuccess = (state, action) => {
  const { feedId } = action;
  let alertsFeed = cloneDeep(state.alertsFeed);
  alertsFeed = filter(alertsFeed, (alert) => alert.id !== feedId);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-save-userinfraction-as-record', a));

  return { ...state, alertsFeed, status };
};
const saveUserInfractionAsRecordFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-save-userinfraction-as-record', a));

  return { ...state, status };
};

const deleteUserInfractionRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-delete-userinfraction');

  return { ...state, status };
};
const deleteUserInfractionSuccess = (state, action) => {
  const { feedId } = action;
  const manualHotListFeed = cloneDeep(state.manualHotListFeed);
  manualHotListFeed.data = filter(manualHotListFeed.data, (alert) => alert.id !== feedId);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-userinfraction', a));

  return { ...state, manualHotListFeed, status };
};
const deleteUserInfractionFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-delete-userinfraction', a));

  return { ...state, status };
};

// const getShiftChecklistFeedRequest = (state) => {
//   const status = cloneDeep(state.status);
//   status.push('pending-get-shift-checklist-feed');

//   return { ...state, status };
// };
// const getShiftChecklistFeedSuccess = (state, action) => {
//   const failedChecklistFeed = action.response;

//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-shift-checklist-feed', a));

//   return {
//     ...state,
//     failedChecklistFeed,
//     status,
//   };
// };
// const getShiftChecklistFeedFailure = (state) => {
//   let status = cloneDeep(state.status);
//   status = filter(status, (a) => !isEqual('pending-get-shift-checklist-feed', a));

//   return { ...state, status };
// };

const markFailedChecklistAsCompletedRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-complete-failed-checklist');

  return { ...state, status };
};
const markFailedChecklistAsCompletedSuccess = (state, action) => {
  const { feedId } = action;
  let failedChecklistFeed = cloneDeep(state.failedChecklistFeed);
  failedChecklistFeed = filter(failedChecklistFeed, (checklist) => checklist.id !== feedId);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-complete-failed-checklist', a));

  return { ...state, failedChecklistFeed, status };
};
const markFailedChecklistAsCompletedFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-complete-failed-checklist', a));

  return { ...state, status };
};

const getShiftHotListFeedRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-shift-hotlist-feed');

  return { ...state, status };
};
const getShiftHotListFeedSuccess = (state, action) => {
  const manualHotListFeed = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-hotlist-feed', a));

  return {
    ...state,
    manualHotListFeed,
    status,
  };
};
const getShiftHotListFeedFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-shift-hotlist-feed', a));

  return { ...state, status };
};

const updateHotListVehicleCommentRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-update-hotlist-vehicle-comment-${action.feedId}-${action.commentId}`);

  return { ...state, status };
};
const updateHotListVehicleCommentSuccess = (state, action) => {
  const { feedId, comment } = action;
  const manualHotListFeed = cloneDeep(state.manualHotListFeed);
  // const hotListIdx = findIndex(manualHotListFeed, (feed) => feed.id === feedId);
  const hotListIdx = manualHotListFeed.data.findIndex((feed) => feed.id === feedId);
  if (
    hotListIdx > -1 &&
    manualHotListFeed.data[hotListIdx].details &&
    manualHotListFeed.data[hotListIdx].details.comments
  ) {
    const { comments } = manualHotListFeed.data[hotListIdx].details;
    const idx = comments.findIndex((e) => isEqual(e.id, comment.id));
    if (idx > -1) {
      comments[idx] = comment;
    }
    manualHotListFeed.data[hotListIdx].details.comments = comments;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-update-hotlist-vehicle-comment-${feedId}-${comment.id}`, a));

  return { ...state, manualHotListFeed, status };
};
const updateHotListVehicleCommentFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(
    status,
    (a) => !isEqual(`pending-update-hotlist-vehicle-comment-${action.feedId}-${action.commentId}`, a),
  );

  return { ...state, status };
};

const deleteHotListVehicleCommentRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-delete-hotlist-vehicle-comment-${action.feedId}-${action.commentId}`);

  return { ...state, status };
};
const deleteHotListVehicleCommentSuccess = (state, action) => {
  const { feedId, commentId } = action;

  const manualHotListFeed = cloneDeep(state.manualHotListFeed);
  // const hotListIdx = findIndex(manualHotListFeed, (feed) => feed.id === feedId);
  const hotListIdx = manualHotListFeed.data.findIndex((feed) => feed.id === feedId);
  if (
    hotListIdx > -1 &&
    manualHotListFeed.data[hotListIdx].details &&
    manualHotListFeed.data[hotListIdx].details.comments
  ) {
    let { comments } = manualHotListFeed.data[hotListIdx].details;
    comments = comments.filter((e) => e.id !== commentId);
    manualHotListFeed.data[hotListIdx].details.comments = comments;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-hotlist-vehicle-comment-${feedId}-${commentId}`, a));

  return { ...state, manualHotListFeed, status };
};
const deleteHotListVehicleCommentFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(
    status,
    (a) => !isEqual(`pending-delete-hotlist-vehicle-comment-${action.feedId}-${action.commentId}`, a),
  );

  return { ...state, status };
};

const archiveManualHotListRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-archive-manual-hot-list');

  return { ...state, status };
};
const archiveManualHotListSuccess = (state, action) => {
  const { feedId } = action;
  const manualHotListFeed = cloneDeep(state.manualHotListFeed);
  // manualHotListFeed = filter(manualHotListFeed, (hotlist) => hotlist.id !== feedId);
  manualHotListFeed.data = manualHotListFeed.data.filter((hotlist) => hotlist.id !== feedId);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-archive-manual-hot-list', a));

  return { ...state, manualHotListFeed, status };
};
const archiveManualHotListFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-archive-manual-hot-list', a));

  return { ...state, status };
};

const clearShiftAdminRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  // [ShiftAdminTypes.GET_ACTIVE_SHIFTS_OVERVIEW_REQUEST]: getActiveShiftsOverviewRequest,
  // [ShiftAdminTypes.GET_ACTIVE_SHIFTS_OVERVIEW_SUCCESS]: getActiveShiftsOverviewSuccess,
  // [ShiftAdminTypes.GET_ACTIVE_SHIFTS_OVERVIEW_FAILURE]: getActiveShiftsOverviewFailure,

  [ShiftAdminTypes.GET_SHIFT_PREV_PERIOD_OVERVIEW_REQUEST]: getShiftPrevPeriodOverviewRequest,
  [ShiftAdminTypes.GET_SHIFT_PREV_PERIOD_OVERVIEW_SUCCESS]: getShiftPrevPeriodOverviewSuccess,
  [ShiftAdminTypes.GET_SHIFT_PREV_PERIOD_OVERVIEW_FAILURE]: getShiftPrevPeriodOverviewFailure,

  [ShiftAdminTypes.GET_SHIFT_COMMISSIONS_REQUEST]: getShiftCommissionsRequest,
  [ShiftAdminTypes.GET_SHIFT_COMMISSIONS_SUCCESS]: getShiftCommissionsSuccess,
  [ShiftAdminTypes.GET_SHIFT_COMMISSIONS_FAILURE]: getShiftCommissionsFailure,

  // [ShiftAdminTypes.GET_SHIFT_ALERTS_FEED_REQUEST]: getShiftAlertsFeedRequest,
  // [ShiftAdminTypes.GET_SHIFT_ALERTS_FEED_SUCCESS]: getShiftAlertsFeedSuccess,
  // [ShiftAdminTypes.GET_SHIFT_ALERTS_FEED_FAILURE]: getShiftAlertsFeedFailure,

  // [ShiftAdminTypes.GET_SHIFT_ALERTS_PAGINATION_FEED_REQUEST]: getShiftAlertsPaginationFeedRequest,
  // [ShiftAdminTypes.GET_SHIFT_ALERTS_PAGINATION_FEED_SUCCESS]: getShiftAlertsPaginationFeedSuccess,
  // [ShiftAdminTypes.GET_SHIFT_ALERTS_PAGINATION_FEED_FAILURE]: getShiftAlertsPaginationFeedFailure,

  [ShiftAdminTypes.SAVE_ALL_INFRACTIONS_REQUEST]: saveAllInfractionsRequest,
  [ShiftAdminTypes.SAVE_ALL_INFRACTIONS_SUCCESS]: saveAllInfractionsSuccess,
  [ShiftAdminTypes.SAVE_ALL_INFRACTIONS_FAILURE]: saveAllInfractionsFailure,

  [ShiftAdminTypes.SAVE_USER_INFRACTION_AS_RECORD_REQUEST]: saveUserInfractionAsRecordRequest,
  [ShiftAdminTypes.SAVE_USER_INFRACTION_AS_RECORD_SUCCESS]: saveUserInfractionAsRecordSuccess,
  [ShiftAdminTypes.SAVE_USER_INFRACTION_AS_RECORD_FAILURE]: saveUserInfractionAsRecordFailure,

  [ShiftAdminTypes.DELETE_USER_INFRACTION_REQUEST]: deleteUserInfractionRequest,
  [ShiftAdminTypes.DELETE_USER_INFRACTION_SUCCESS]: deleteUserInfractionSuccess,
  [ShiftAdminTypes.DELETE_USER_INFRACTION_FAILURE]: deleteUserInfractionFailure,

  // [ShiftAdminTypes.GET_SHIFT_CHECKLIST_FEED_REQUEST]: getShiftChecklistFeedRequest,
  // [ShiftAdminTypes.GET_SHIFT_CHECKLIST_FEED_SUCCESS]: getShiftChecklistFeedSuccess,
  // [ShiftAdminTypes.GET_SHIFT_CHECKLIST_FEED_FAILURE]: getShiftChecklistFeedFailure,

  [ShiftAdminTypes.MARK_FAILED_CHECKLIST_AS_COMPLETED_REQUEST]: markFailedChecklistAsCompletedRequest,
  [ShiftAdminTypes.MARK_FAILED_CHECKLIST_AS_COMPLETED_SUCCESS]: markFailedChecklistAsCompletedSuccess,
  [ShiftAdminTypes.MARK_FAILED_CHECKLIST_AS_COMPLETED_FAILURE]: markFailedChecklistAsCompletedFailure,

  [ShiftAdminTypes.GET_SHIFT_HOT_LIST_FEED_REQUEST]: getShiftHotListFeedRequest,
  [ShiftAdminTypes.GET_SHIFT_HOT_LIST_FEED_SUCCESS]: getShiftHotListFeedSuccess,
  [ShiftAdminTypes.GET_SHIFT_HOT_LIST_FEED_FAILURE]: getShiftHotListFeedFailure,

  [ShiftAdminTypes.UPDATE_HOT_LIST_VEHICLE_COMMENT_REQUEST]: updateHotListVehicleCommentRequest,
  [ShiftAdminTypes.UPDATE_HOT_LIST_VEHICLE_COMMENT_SUCCESS]: updateHotListVehicleCommentSuccess,
  [ShiftAdminTypes.UPDATE_HOT_LIST_VEHICLE_COMMENT_FAILURE]: updateHotListVehicleCommentFailure,

  [ShiftAdminTypes.DELETE_HOT_LIST_VEHICLE_COMMENT_REQUEST]: deleteHotListVehicleCommentRequest,
  [ShiftAdminTypes.DELETE_HOT_LIST_VEHICLE_COMMENT_SUCCESS]: deleteHotListVehicleCommentSuccess,
  [ShiftAdminTypes.DELETE_HOT_LIST_VEHICLE_COMMENT_FAILURE]: deleteHotListVehicleCommentFailure,

  [ShiftAdminTypes.ARCHIVE_MANUAL_HOT_LIST_REQUEST]: archiveManualHotListRequest,
  [ShiftAdminTypes.ARCHIVE_MANUAL_HOT_LIST_SUCCESS]: archiveManualHotListSuccess,
  [ShiftAdminTypes.ARCHIVE_MANUAL_HOT_LIST_FAILURE]: archiveManualHotListFailure,

  [ShiftAdminTypes.CLEAR_SHIFT_ADMIN_REQUEST]: clearShiftAdminRequest,
});
